import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const alumniData = [
  {
    name: 'Jesse Sekidika',
    club: 'Galatasaray SK',
    country: 'Turkey',
    flag: '\u{1F1F9}\u{1F1F7}',
    clubBg: 'from-red-700 to-yellow-600'
  },
  {
    name: 'Adli Mohamed',
    club: 'Southampton FC',
    country: 'England',
    flag: '\u{1F3F4}\u{E0067}\u{E0062}\u{E0065}\u{E006E}\u{E0067}\u{E007F}',
    clubBg: 'from-red-600 to-red-800'
  },
  {
    name: 'Kelvin John',
    club: 'KRC Genk',
    country: 'Belgium',
    flag: '\u{1F1E7}\u{1F1EA}',
    clubBg: 'from-blue-600 to-blue-800'
  }
];

const sectionText = {
  en: {
    badge: 'Alumni Success',
    title: 'Where Are They Now?',
    subtitle: 'From Oakham Football Camps to professional football — our alumni are competing at the highest levels across Europe.',
    playingFor: 'Playing for'
  },
  es: {
    badge: 'Éxito de Exalumnos',
    title: '¿Dónde Están Ahora?',
    subtitle: 'De los Oakham Football Camps al fútbol profesional — nuestros exalumnos compiten al más alto nivel en toda Europa.',
    playingFor: 'Juega en'
  },
  fr: {
    badge: 'Succès des Anciens',
    title: 'Où Sont-Ils Maintenant?',
    subtitle: 'Des Oakham Football Camps au football professionnel — nos anciens compétitent au plus haut niveau à travers l\'Europe.',
    playingFor: 'Joue pour'
  }
};

const AlumniSection = () => {
  const { language } = useLanguage();
  const text = sectionText[language] || sectionText.en;

  return (
    <section className="py-16 bg-gray-900 text-white" data-testid="alumni-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="inline-block bg-green-600/20 border border-green-500/30 text-green-400 text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4">
            {text.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-black mb-3">{text.title}</h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base">
            {text.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {alumniData.map((alumni, index) => (
            <div
              key={index}
              className={`relative bg-gradient-to-br ${alumni.clubBg} rounded-xl p-6 text-center transform hover:scale-105 transition-all duration-300 shadow-lg`}
              data-testid={`alumni-card-${index}`}
            >
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center border-2 border-white/30">
                <span className="text-3xl">{alumni.flag}</span>
              </div>
              <h3 className="text-lg font-black text-white mb-1">{alumni.name}</h3>
              <p className="text-white/80 text-sm font-medium">{text.playingFor}</p>
              <p className="text-white font-bold text-base mt-1">{alumni.club}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AlumniSection;
